import { render, staticRenderFns } from "./MedicamentosPendentes.vue?vue&type=template&id=492d1ffa&"
import script from "./MedicamentosPendentes.vue?vue&type=script&lang=js&"
export * from "./MedicamentosPendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports